/// <reference path='../../core/contracts/quote.contracts.ts'/>
/// <reference path='../../quote/controllers/quotePublic.controller.ts'/>
/// <reference path='../../core/services/quote.service.ts'/>
/// <reference path='../../core/services/resource.service.ts'/>
/// <reference path="../../../../../../typings/globals/angular/index.d.ts" />
/// <reference path="../../../../../../typings/globals/lodash/index.d.ts" />

namespace ekh {

    class QuoteStatusMessagesController {
        private phoneNumber: string;
        private quoteStatus: Quote.QuoteControllerStatus;
        private priceDifferencePercentage: number;
        private quoteRef: string;
        private samePriceRange: number;

        constructor(
            private resourceService: Core.ResourceService,
        ) {
            this.phoneNumber = this.resourceService.get('TELEPHONENUMBER');
            const priceRange = parseFloat(TRPCONFIG.Domain2.QuoteSamePricePercentRange);
            this.samePriceRange = !isNaN(priceRange) ? priceRange : 0;
        }

        public getTitle(messType) {
            switch(messType) {
                case 'EXPIRED':
                    return String.format(this.resourceService.get('QUOTE_STATUS_MESSAGE_EXPIRED_TITLE'), this.quoteRef);
                default:
                    return String.format(this.resourceService.get('QUOTE_STATUS_MESSAGE_TITLE'), this.quoteRef);
            }
        }

        public getMessageText(messType) {
            switch(messType) {
                case 'EXPIRED':
                    return String.format(this.resourceService.get('QUOTE_STATUS_MESSAGE_EXPIRED_TEXT'),
                        `<b>${this.phoneNumber}</b>`);
                case 'PRICE_DECREASED':
                    return this.resourceService.get('QUOTE_STATUS_MESSAGE_PRICE_DECREASED_TEXT');
                case 'PRICE_INCREASED':
                    return this.resourceService.get('QUOTE_STATUS_MESSAGE_PRICE_INCREASED_TEXT');
                default:
                    return '';
            }
        }

        public isExpiredMessage() {
            return this.quoteStatus !== Quote.QuoteControllerStatus.Ready &&
                this.quoteStatus !== Quote.QuoteControllerStatus.Busy;
        }

        public isPriceDecreasedMessage() {
            if (this.quoteStatus !== Quote.QuoteControllerStatus.Ready) {
                return false;
            }
            return !this.isSamePriceMessage() && this.priceDifferencePercentage < 0;
        }

        public isPriceIncreasedMessage() {
            if (this.quoteStatus !== Quote.QuoteControllerStatus.Ready) {
                return false;
            }
            return !this.isSamePriceMessage() && this.priceDifferencePercentage > 0;
        }

        public isSamePriceMessage() {
            if (this.quoteStatus !== Quote.QuoteControllerStatus.Ready) {
                return false;
            }
            return Math.abs(this.priceDifferencePercentage) <= this.samePriceRange;
        }

        public getButtonLabel() {
            return this.resourceService.get('HOLIDAYSEARCH');
        }
    }

    angular
        .module('ekh')
        .directive('quoteStatusMessages', function() {
            return {
                restrict: 'E',
                replace: true,
                controllerAs: 'quoteMess',
                bindToController: {
                    quoteStatus: '=',
                    priceDifferencePercentage: '=',
                    quoteRef: '='
                },
                controller: QuoteStatusMessagesController,
                template: `
                    <div class="quote-status-messages">

                        <div class="message-block expired-quote" ng-if-start="quoteMess.isExpiredMessage()">
                            <div class="quote-ref" ng-bind-html="::quoteMess.getTitle('EXPIRED')"></div>
                            <div class="message" ng-bind-html="::quoteMess.getMessageText('EXPIRED')"></div>
                        </div>
                        <a href="./" ng-if-end class="button primary">
                            {{::quoteMess.getButtonLabel()}}
                        </a>
            
                        <div class="message-block increased-price" ng-if="quoteMess.isPriceIncreasedMessage()">
                            <div class="quote-ref" ng-bind-html="::quoteMess.getTitle('PRICE_INCREASED')"></div>
                            <div class="message" ng-bind-html="::quoteMess.getMessageText('PRICE_INCREASED')"></div>
                        </div>
            
                        <div class="message-block decreased-price" ng-if="quoteMess.isPriceDecreasedMessage()">
                            <div class="quote-ref" ng-bind-html="::quoteMess.getTitle('PRICE_DECREASED')"></div>
                            <div class="message" ng-bind-html="::quoteMess.getMessageText('PRICE_DECREASED')"></div>
                        </div>
                        
                        <div class="message-block same-price" ng-if="quoteMess.isSamePriceMessage()">
                            <div class="quote-ref" ng-bind-html="::quoteMess.getTitle('SAME_PRICE')"></div>
                        </div>
            
                    </div>
                `,
            };
        });
}
